import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Button from '@/components/base/Button';
import Checkbox from '@/components/base/Checkbox';
import Icon from '@/components/base/Icon';
import AddTags from '@/components/pages/media/components/AddTags';

const HeadingActions = ({
    isLoading,
    onChange,
    selectedIds,
    nbMediaVisible,
    toggleDeleteModal,
    className,
    availableTags,
    mutateLibraryMedia,
    inCommonTags
}) => {
    const { t } = useTranslation('media');
    return (
        <div
            className={clsx(
                'manipulation-header flex flex-col justify-between gap-3 xs:flex-row',
                className
            )}>
            <div className="order-2 flex h-min flex-col gap-3 xs:order-1 md:flex-row">
                <Button
                    variant="white"
                    className="border-none xs:w-max"
                    onClick={onChange}
                    disabled={isLoading || nbMediaVisible === 0}>
                    <Checkbox
                        disabled={isLoading || nbMediaVisible === 0}
                        className="mr-3"
                        checked={selectedIds.length > 0}
                        readOnly
                    />
                    <div className="text-sm dark:text-white">
                        {selectedIds.length === 0
                            ? t('add_select_media_zero', { count: nbMediaVisible || '0' })
                            : null}
                        {selectedIds.length === 1
                            ? t('add_select_media_one', { count: selectedIds.length })
                            : null}
                        {selectedIds.length > 1
                            ? t('add_select_media_other', { count: selectedIds.length })
                            : null}
                    </div>
                </Button>
                {selectedIds.length > 0 ? (
                    <>
                        <div className="relative flex flex-col">
                            <AddTags
                                selectedMediaIds={selectedIds}
                                availableTags={availableTags}
                                mutateLibraryMedia={mutateLibraryMedia}
                                displayOnlyAddedTags={true}
                                mediaTags={inCommonTags}
                                renderButton={(setReferenceElement, toggle) => (
                                    <Button
                                        variant="white"
                                        className="w-min border-none"
                                        onClick={toggle}
                                        ref={setReferenceElement}>
                                        <Icon icon="labels" className="mr-3 text-icoGray-500" />
                                        {t('filter_add_tags_btn')}
                                    </Button>
                                )}
                            />
                        </div>
                        <Button variant="white" className="border-none" onClick={toggleDeleteModal}>
                            <Icon icon="trash" className="mr-3 text-icoGray-500" />
                            {t('commons:delete')}
                        </Button>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default HeadingActions;
